module.exports = __webpack_public_path__ + "static/media/website_link.c583cabf.png";